var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_5342)",
    filter: "url(#filter0_d_624_5342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3386 6.99751L10.1098 7.52876M5.4711 2.89001L6.00235 4.66043L5.4711 2.89001Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86777 5.13213L10.2674 2.73254",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29166 2.91663C5.63683 2.91663 5.91666 2.6368 5.91666 2.29163C5.91666 1.94645 5.63683 1.66663 5.29166 1.66663C4.94648 1.66663 4.66666 1.94645 4.66666 2.29163C4.66666 2.6368 4.94648 2.91663 5.29166 2.91663Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7083 2.91663C11.0535 2.91663 11.3333 2.6368 11.3333 2.29163C11.3333 1.94645 11.0535 1.66663 10.7083 1.66663C10.3632 1.66663 10.0833 1.94645 10.0833 2.29163C10.0833 2.6368 10.3632 2.91663 10.7083 2.91663Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7083 8.33337C11.0535 8.33337 11.3333 8.05355 11.3333 7.70837C11.3333 7.3632 11.0535 7.08337 10.7083 7.08337C10.3632 7.08337 10.0833 7.3632 10.0833 7.70837C10.0833 8.05355 10.3632 8.33337 10.7083 8.33337Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54166 8.33337C7.57719 8.33337 8.41666 7.49391 8.41666 6.45837C8.41666 5.42284 7.57719 4.58337 6.54166 4.58337C5.50612 4.58337 4.66666 5.42284 4.66666 6.45837C4.66666 7.49391 5.50612 8.33337 6.54166 8.33337Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_624_5342",
    x: -1,
    y: 0,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_624_5342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_624_5342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_5342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate);
export default __webpack_public_path__ + "static/media/affiliate.d3a54c7bcefcccb682460bc1b9c314fe.svg";
export { ForwardRef as ReactComponent };